module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-80.2b16312.woff2";